import { Typography, styled } from '@mui/material'

export const SelectTimeTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.primaryRange[100]};
`
